import React, { useState } from 'react'
import './ForWho.scss'
import { useLanguage } from '../Contexts/LanguageContext';

const ForWho = () => {
    const [isOneOpen, setIsOneOpen] = useState(false);
    const [isTwoOpen, setIsTwoOpen] = useState(false);
    const { language } = useLanguage();

    const toggleOne = () => setIsOneOpen(prev => !prev);
    const toggleTwo = () => setIsTwoOpen(prev => !prev);

    const keyToggle = (fn) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fn();
        }
    };

    return (
        <div className='for-who' id='dla-kogo'>
            <h2>{language === 'polish' ? 'Dla kogo jest ta platforma?' : 'Who is this platform for?'}</h2>
            <div className='content'>
                <div className='accordion'>
                    {/* --- Sekcja 1 --- */}
                    <div className={`accordion-title ${isOneOpen ? 'active-title' : ''}`}>
                        <h3>{language === 'polish' ? 'Reklamodawcy' : 'Advertisers'}</h3>

                        <svg
                            width="37" height="37" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg"
                            className={`icon plus-icon-one ${isOneOpen ? 'active-plus' : ''}`}
                            role="button"
                            tabIndex={0}
                            aria-label="Rozwiń/Zwiń"
                            aria-expanded={isOneOpen}
                            onClick={toggleOne}
                            onKeyDown={keyToggle(toggleOne)}
                        >
                            <path d="M17 36.8823V20.3823H0.5V17.3823H17V0.882324H20V17.3823H36.5V20.3823H20V36.8823H17Z" fill="#1C1B1F" />
                        </svg>
                    </div>
                    <div className={`accordion-content-one ${isOneOpen ? 'active-content' : ''}`}>
                        <p>{language === 'polish' ? 'e-commerce | fintech / crypto | mobilki / aplikacje' : 'e-commerce | fintech / crypto | mobile / applications'}</p>
                        <p>
                            {language === 'polish' ? 'Clinknest to platforma stworzona z myślą o twórcach na Telegramie. Umożliwia łatwą monetyzację kanałów, zarządzanie współpracami i pełną kontrolę nad tym, jakie reklamy trafiają do Twojej społeczności. Dzięki intuicyjnemu panelowi i przejrzystej analityce zyskujesz narzędzia do rozwijania swojego kanału, budowania większego zaangażowania i maksymalizowania zysków z treści. Niezależnie od tego, czy prowadzisz małą niszową grupę, czy ogromny kanał tematyczny – Clinknest wspiera Twój rozwój i daje Ci nowe możliwości zarabiania.' : 'Clinknest is a platform designed for creators on Telegram. It enables easy monetization of channels, management of collaborations, and full control over the ads that reach your community. With an intuitive panel and clear analytics, you gain tools to grow your channel, build greater engagement, and maximize content revenue. Whether you run a small niche group or a large thematic channel, Clinknest supports your growth and provides new earning opportunities.'}
                        </p>
                    </div>

                    {/* --- Sekcja 2 --- */}
                    <div className={`accordion-title ${isTwoOpen ? 'active-title' : ''}`}>
                        <h3>{language === 'polish' ? 'Wydawcy Telegrama' : 'Telegram Publishers'}</h3>
                        <svg
                            width="37" height="37" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg"
                            className={`icon plus-icon-two ${isTwoOpen ? 'active-plus' : ''}`}
                            role="button"
                            tabIndex={0}
                            aria-label="Rozwiń/Zwiń"
                            aria-expanded={isTwoOpen}
                            onClick={toggleTwo}
                            onKeyDown={keyToggle(toggleTwo)}
                        >
                            <path d="M17 36.8823V20.3823H0.5V17.3823H17V0.882324H20V17.3823H36.5V20.3823H20V36.8823H17Z" fill="#1C1B1F" />
                        </svg>
                    </div>
                    <div className={`accordion-content-two ${isTwoOpen ? 'active-content' : ''}`}>
                        <p>{language === 'polish' ? 'e-commerce | fintech / crypto | mobilki / aplikacje' : 'e-commerce | fintech / crypto | mobile / applications'}</p>
                        <p>
                            {language === 'polish' ? 'Clinknest to platforma stworzona z myślą o reklamodawcach z dynamicznych branż takich jak e-commerce, fintech / crypto oraz mobile / aplikacje. Umożliwia precyzyjne zarządzanie kampaniami, analizę efektywności i pełną kontrolę nad budżetem. Dzięki intuicyjnemu panelowi i zaawansowanej analityce, Clinknest pomaga szybko skalować wyniki, docierać do właściwych odbiorców i maksymalizować ROI – niezależnie od tego, czy promujesz sklep internetowy, aplikację mobilną czy innowacyjne rozwiązania finansowe.' : 'Clinknest is a platform designed for advertisers from dynamic industries such as e-commerce, fintech / crypto, and mobile / applications. It enables precise campaign management, performance analysis, and full budget control. With an intuitive panel and advanced analytics, Clinknest helps quickly scale results, reach the right audiences, and maximize ROI – whether you are promoting an online store, a mobile app, or innovative financial solutions.'}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForWho
